function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.085,
    height: 19.279,
    viewBox: "0 0 16.085 19.279",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "user (7)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5082",
    d: "M91.675 9.287a4.493 4.493 0 0 0 3.283-1.36 4.493 4.493 0 0 0 1.36-3.283 4.494 4.494 0 0 0-1.36-3.283 4.642 4.642 0 0 0-6.566 0 4.493 4.493 0 0 0-1.36 3.283 4.493 4.493 0 0 0 1.361 3.283 4.494 4.494 0 0 0 3.282 1.36zm0 0",
    transform: "translate(-83.755)",
    style: {
      fill: "#aeaeae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5083",
    d: "M16.045 252.828a11.47 11.47 0 0 0-.156-1.218 9.6 9.6 0 0 0-.3-1.225 6.049 6.049 0 0 0-.5-1.142 4.311 4.311 0 0 0-.759-.989 3.347 3.347 0 0 0-1.091-.685 3.769 3.769 0 0 0-1.392-.252 1.413 1.413 0 0 0-.755.32c-.226.148-.491.318-.786.507a4.507 4.507 0 0 1-1.017.448 3.95 3.95 0 0 1-2.488 0 4.494 4.494 0 0 1-1.017-.448c-.293-.187-.557-.358-.787-.507a1.411 1.411 0 0 0-.754-.32 3.765 3.765 0 0 0-1.392.252 3.345 3.345 0 0 0-1.091.685 4.311 4.311 0 0 0-.759.989 6.062 6.062 0 0 0-.5 1.142 9.62 9.62 0 0 0-.3 1.225 11.428 11.428 0 0 0-.156 1.219c-.026.369-.039.752-.039 1.138a3.2 3.2 0 0 0 .951 2.422 3.423 3.423 0 0 0 2.45.894h9.283a3.422 3.422 0 0 0 2.45-.894 3.2 3.2 0 0 0 .951-2.422c0-.388-.013-.772-.039-1.139zm0 0",
    transform: "translate(0 -238.004)",
    style: {
      fill: "#aeaeae"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.a53d946fd8f5708d9b842b9e9bb98b00.svg";
export { ForwardRef as ReactComponent };